import { render, staticRenderFns } from "./lista_tipo_reportes.vue?vue&type=template&id=252cf99c&scoped=true"
import script from "./lista_tipo_reportes.vue?vue&type=script&lang=js"
export * from "./lista_tipo_reportes.vue?vue&type=script&lang=js"
import style0 from "./lista_tipo_reportes.vue?vue&type=style&index=0&id=252cf99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252cf99c",
  null
  
)

export default component.exports